<atx-input-with-icon
  size="lg"
  class="d-block my-3"
  data-e2e="search-accounts"
  [icon]="['fas', 'magnifying-glass']"
  [initialValue]="''"
  i18n-placeholderText="
    accountSelector|Placeholder text for the search
    field@@searchForShopPlaceholder"
  placeholderText="Search for a shop"
  [updateOnEvents]="true"
  [debounceTime]="searchDebounce$ | async"
  [ignoreConsequentInputs]="noResult$ | async"
  (valueChange)="queryChanges$.next($event)"
></atx-input-with-icon>
